/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_COMMON_DROPDOWN_DATA_CI = 'GET_COMMON_DROPDOWN_DATA_CI';
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
export const STATUS_SELECTED_TYPE = 'STATUS_SELECTED_TYPE';
export const RESET_DISPUTES_DATA = 'RESET_DISPUTES_DATA';
export const GET_MANUFACTURER_GRID_LIST = 'GET_MANUFACTURER_GRID_LIST';
export const ASSIGNED_USERS_LIST = 'ASSIGNED_USERS_LIST';
export const DISPUTE_HEADER_DETAILS = 'DISPUTE_HEADER_DETAILS';
export const SINGLE_HEADER_DETAILS = 'SINGLE_HEADER_DETAILS';
export const DISPUTE_BODY_DETAILS = 'DISPUTE_BODY_DETAILS';
export const DISPUTE_DETAILS_CORRESPONDENCE = 'DISPUTE_DETAILS_CORRESPONDENCE';
export const DISPUTE_NDC_DETAILS = 'DISPUTE_NDC_DETAILS';
export const HANDLE_ERROR_MESSAGE = 'HANDLE_ERROR_MESSAGE';
export const SINGLE_DISPUTE_NDC_DETAILS = 'SINGLE_DISPUTE_NDC_DETAILS';
export const DETAIL_ERROR_MESSAGE = 'DETAIL_ERROR_MESSAGE';
export const NDC_DETAIL_ERROR_MESSAGE = 'NDC_DETAIL_ERROR_MESSAGE';
export const DROPDOWN_UPDATED_LIST = 'DROPDOWN_UPDATED_LIST';
export const GET_DISPUTE_CODES = 'GET_DISPUTE_CODES';
export const GET_DISPLAY_RECAP_GRID = 'GET_DISPLAY_RECAP_GRID';
